import './App.scss';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';

import { isAuthPage } from 'utils/utils';
import { LOCALSTORAGE } from 'utils/constants';

import { getLoggedInUser, setToken } from 'containers/Auth/store/actions';
import { getConversations } from 'containers/Messaging/store/actions';

import LoadingCircle from 'components/LoadingCircle';
import MainFooter from 'components/MainFooter';
import MainHeader from 'components/MainHeader';
import Home from "../Home";

class App extends React.Component {
    constructor() {
        super();

        this.conversationsTimer = null;
    }

    componentWillMount() {
        let authToken = localStorage.getItem(LOCALSTORAGE.ID_TOKEN);
        let pathname = this.props.routing.locationBeforeTransitions.pathname;

        console.log(authToken)

        if(authToken == null && isAuthPage(pathname) !== true) {
            if(window.location.pathname !== '/') {
                let redirectString = `${window.location.pathname}||${new Date().getTime()}`;
                localStorage.setItem('login_redirect', redirectString);
            }
            this.props.changeLocation('/login');
        } else if(authToken != null) {
            this.props.setToken(authToken);
            this.props.getLoggedInUser(authToken)
                .then((res) => {
                    this.props.setToken(authToken);
                    if(this.userSubscriptionStatusIsLocked()) {
                        this.props.changeLocation('/account/billing');
                    } else if(isAuthPage(pathname) || pathname === '/') {
                        this.props.changeLocation('/account/profile');
                    }
                })
                .catch((err) => {
                    if(isAuthPage(pathname) === false) {
                        this.props.changeLocation('/logout');
                    }
                })
        }
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.auth.user.id !== nextProps.auth.user.id) {
            if(this.props.auth.user.id != null && nextProps.auth.user.id == null) {
                window.clearTimeout(this.conversationsTimer);
            } else if(this.props.auth.user.id == null) {
                this._getConversations();
            }
        }
    }

    userSubscriptionStatusIsLocked = () => {
        return (
            this.props.auth.token &&
            this.props.auth.user.isFreelancer !== true &&
            this.props.routing.locationBeforeTransitions.pathname !== '/account/business' &&
            this.props.auth.user.company &&
            !this.props.auth.user.company.isLifetimeMember &&
            (this.props.auth.user.company.subscriptionType === 'free' || !(/active|trialing/.test(this.props.auth.user.company.subscriptionStatus)))
        )
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.routing.locationBeforeTransitions.pathname !== this.props.routing.locationBeforeTransitions.pathname &&
            this.userSubscriptionStatusIsLocked()
        ) {
            console.log(prevProps.routing.locationBeforeTransitions.pathname, this.props.routing.locationBeforeTransitions.pathname)
            this.props.changeLocation('/account/billing');
        }
    }

    componentWillUnmount() {
        window.clearTimeout(this.conversationsTimer);
    }

    _getConversations() {
        this.props.getConversations(true)
        .then(() => {
            this.conversationsTimer = setTimeout(() => {
                this._getConversations();
            }, 5000)
        })
        .catch(err => {
            console.log(err);
        });


    }

    render() {
        return (
            <div className="wrapper">
                <MainHeader
                    hasUnreadMessages={this.props.messaging.hasUnreadMessages}
                    pathname={this.props.routing.locationBeforeTransitions.pathname}
                    hasToken={this.props.auth.token != null}
                    user={this.props.auth.user}
                />

                {this.props.auth.isFetching === true ? (
                    <LoadingCircle/>
                ) : this.props.children}

                <MainFooter pathname={this.props.routing.locationBeforeTransitions.pathname}/>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        app: state.app,
        auth: state.auth,
        errors: state.errors,
        location: state.location,
        messaging: state.messaging,
        redeem: state.redeem,
        routing: state.routing
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        getConversations: (hideSpinner) => dispatch(getConversations(hideSpinner)),
        getLoggedInUser: (token) => dispatch(getLoggedInUser(token)),
        setToken: (token) => dispatch(setToken(token))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.js